var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedIn28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.372 3H4.622A1.606 1.606 0 0 0 3 4.586v18.827a1.607 1.607 0 0 0 1.623 1.588h18.75A1.61 1.61 0 0 0 25 23.413V4.586A1.608 1.608 0 0 0 23.372 3ZM9.526 21.747H6.26v-10.5h3.266v10.5ZM7.894 9.814a1.892 1.892 0 1 1-.002-3.785 1.892 1.892 0 0 1 .002 3.784Zm13.854 11.933h-3.263v-5.106c0-1.217-.021-2.783-1.696-2.783-1.698 0-1.957 1.326-1.957 2.696v5.193h-3.26v-10.5h3.129v1.436h.045a3.429 3.429 0 0 1 3.087-1.696c3.304 0 3.914 2.174 3.914 5.002v5.758Z"
})));
export { SvgLinkedIn28 as ReactComponent };
export default __webpack_public_path__ + "afa19917a205834fcb6dca02f76aa13e.svg";